import { render, staticRenderFns } from "./TsAccountingFormat.vue?vue&type=template&id=e9f23b44&"
import script from "./TsAccountingFormat.vue?vue&type=script&lang=js&"
export * from "./TsAccountingFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports